import { render, staticRenderFns } from "./AssessmentWizard.vue?vue&type=template&id=1bf8cc4c&scoped=true"
import script from "./AssessmentWizard.vue?vue&type=script&lang=js"
export * from "./AssessmentWizard.vue?vue&type=script&lang=js"
import style0 from "./AssessmentWizard.vue?vue&type=style&index=0&id=1bf8cc4c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf8cc4c",
  null
  
)

export default component.exports